export default remote => ({
    verifyBankAccount: (iban) => remote.post(`payment-helper/verify-bank-account`, { iban })
});
